import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const Footer = () => {
  return (
    <footer className="border-t border-slate-800/50 bg-slate-950/80 backdrop-blur-md mt-auto">
      <div className="max-w-6xl mx-auto px-6 py-8">
        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          
          {/* Command Line Style Branding */}
          <div className="font-mono text-sm text-slate-500 flex items-center gap-2">
            <span className="text-emerald-400">guest@indie-dev</span>
            <span className="text-slate-600">:</span>
            <span className="text-purple-400">~</span>
            <span className="text-slate-600">$</span>
            <span className="typing-animation text-slate-400"> exit</span>
          </div>

          {/* Socials */}
          <div className="flex space-x-6">
            <a href="#" className="text-slate-500 hover:text-emerald-400 transition-colors">
              <span className="sr-only">GitHub</span>
              <SafeIcon icon={FiIcons.FiGithub} className="text-xl" />
            </a>
            <a href="#" className="text-slate-500 hover:text-emerald-400 transition-colors">
              <span className="sr-only">Twitter</span>
              <SafeIcon icon={FiIcons.FiTwitter} className="text-xl" />
            </a>
            <a href="#" className="text-slate-500 hover:text-emerald-400 transition-colors">
              <span className="sr-only">LinkedIn</span>
              <SafeIcon icon={FiIcons.FiLinkedin} className="text-xl" />
            </a>
            <a href="#" className="text-slate-500 hover:text-emerald-400 transition-colors">
              <span className="sr-only">RSS</span>
              <SafeIcon icon={FiIcons.FiRss} className="text-xl" />
            </a>
          </div>

          {/* Copyright */}
          <div className="text-sm text-slate-600">
            &copy; {new Date().getFullYear()} NexAI. All rights reserved.
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;